<mat-dialog-content class="modal-header"><h2 mat-dialog-title>REGISTRAR PERSONAL</h2></mat-dialog-content>

<form #modelForm="ngForm" (ngSubmit)="onSubmit(modelForm)" appIdentityRevealed>
  
<mat-dialog-content class="modal-body">
  <div class="content">
    <div class="form-horizontal">
        <div class="form-group">
            <label class="col-md-2 control-label">Apellido paterno (*):</label>
            <div class="col-md-4">
              <mat-form-field appearance="outline" hideRequiredMarker>
                <mat-label>Apellido paterno</mat-label>
                <input matInput type="text" placeholder="apellido paterno" [(ngModel)]="data.persona.apellidoPaterno" [disabled]="!data.enableEdit" maxlength="40"
                  name="apellidoPaterno"
                  required
                >
                <!-- [readonly]="data.enableEdit"  -->
              </mat-form-field>                
            </div>
            <label class="col-md-2 control-label">Apellido materno (*):</label>
            <div class="col-md-4">
              <mat-form-field appearance="outline" hideRequiredMarker>
                <mat-label>Apellido materno</mat-label>
                <input matInput type="text" placeholder="apellido materno" [(ngModel)]="data.persona.apellidoMaterno" [disabled]="!data.enableEdit" maxlength="40"
                  name="apellidoMaterno"
                  required
                >
              </mat-form-field>
            </div>  
        </div>   
        <div class="form-group">
          <label class="col-md-2 control-label">Nombres (*):</label>
          <div class="col-md-4">
            <mat-form-field appearance="outline" hideRequiredMarker>
              <mat-label>Nombres</mat-label>
              <input matInput type="text" placeholder="nombres" [(ngModel)]="data.persona.nombres" [disabled]="!data.enableEdit" maxlength="40"
                name="nombres"
                required
              >
            </mat-form-field>            
          </div>  

          <label class="col-md-2 control-label">Cargo (*):</label>
        <div class="col-md-4">
          <mat-form-field appearance="outline" hideRequiredMarker>
            <mat-label>Cargo</mat-label>
            <input matInput type="text" placeholder="cargo" [(ngModel)]="data.persona.cargo" [disabled]="!data.enableEdit"  maxlength="80"
              name="cargo" required
            >
          </mat-form-field>          
        </div>  
          
      </div>
      <div class="form-group">
        <label class="col-md-2 control-label">Tipo de Documento de Identidad (*):</label>
      <div class="col-md-4">
        <mat-form-field appearance="outline" hideRequiredMarker>
          <mat-label>Seleccione</mat-label>
          <mat-select
            matSelect
            [(ngModel)]="data.persona.idTipoDocumentoIdentidadSelected"
            name="idTipoDocumentoIdentidadSelected"
            [disabled]="!data.enableEdit"
            required
          >
            <mat-option
              *ngFor="let item of listaTipoDocumentoIdentidad; index as i"
              [value]="item.idParametroDetalle"
              >{{ item.nombre }}</mat-option
            >
          </mat-select>
        </mat-form-field>
      </div>
        <label class="col-md-2 control-label">Nro Documento Identidad (*):</label>
          <div class="col-md-4">
            <mat-form-field appearance="outline" hideRequiredMarker>
              <mat-label>Nro Documento Identidad</mat-label>
              <input matInput type="text" placeholder="Nro Documento Identidad" [(ngModel)]="data.persona.nroDocumentoIdentidad" [disabled]="!data.enableEdit" maxlength="15" 
              name="nroDocumentoIdentidad"
              pattern="^[A-Za-z0-9]*$"
              (keypress)="keyPressAlfanumericoOnly($event)"
              required
              >
            </mat-form-field>            
          </div>           
          
      </div>
      <div class="form-group">

        <label class="col-md-2 control-label">Correo (*):</label>
      <div class="col-md-4">
        <mat-form-field appearance="outline" hideRequiredMarker>
          <mat-label>Correo</mat-label>
          <input matInput type="text" placeholder="correo" [(ngModel)]="data.persona.correo" [pattern]="emailPattern" #offEmail="ngModel" [disabled]="!data.enableEdit" maxlength="100"
            name="correo" required
          >
        </mat-form-field>
      </div>  
        
    </div>
    </div>  
  </div>  
  <div class="content">
    <div class="block">
      <!-- <div class="block-header">
        <h3 class="block-title">Documentación Requerida</h3>
      </div> -->

      <mat-tab-group>
        <mat-tab label="Documentación Requerida">
        <div class="table-responsive">
          <table mat-table [dataSource]="data.persona.documentos" class="table table-striped table-vcenter">
            <ng-container matColumnDef="nombre">
              <th mat-header-cell *matHeaderCellDef>Nombre</th>
              <td mat-cell *matCellDef="let element">{{ element.documento }}</td>
            </ng-container>
    
            <ng-container matColumnDef="idRequisito">
              <th mat-header-cell *matHeaderCellDef>Requisito</th>
              <td mat-cell *matCellDef="let element">{{ element.requisito }}</td>
            </ng-container>

            <ng-container matColumnDef="fechaVencimiento">
              <th mat-header-cell *matHeaderCellDef>Fecha de vencimiento</th>
              <td mat-cell *matCellDef="let element; let i = index">
                <ng-container *ngIf="element.idEstado == 1">
                  {{ element.fechaVencimiento | date:'dd/MM/yyyy' }}
                </ng-container>

                <ng-container *ngIf="element.idEstado !== 1">                  
                  <mat-form-field appearance="outline" *ngIf="element.controlarFechas">
                    <input
                      matInput
                      [matDatepicker]="pckrFechaVencimiento"
                      [(ngModel)]="element.fechaVencimiento"
                      [disabled]="element.idEstado == 1"
                      id="fechaVencimiento"
                      [name]="'fechaVencimiento_'+ i"
                    />
                    <mat-datepicker-toggle
                      matSuffix
                      [for]="pckrFechaVencimiento"
                    ></mat-datepicker-toggle>
                    <mat-datepicker #pckrFechaVencimiento></mat-datepicker>    
                  </mat-form-field>
                </ng-container>

              </td>
            </ng-container>

            <ng-container matColumnDef="idDocumento">
              <th mat-header-cell *matHeaderCellDef>Doc.</th>
              <td mat-cell *matCellDef="let element">
                <!-- <a>VER</a> -->
                <a (click)="downloadDocumentFromService(element)">{{element.nombreArchivo}}</a>
              </td>
            </ng-container>

            <ng-container matColumnDef="estado">
              <th mat-header-cell *matHeaderCellDef>Estado</th>
              <td mat-cell *matCellDef="let element">
                <!-- <a>VER</a> -->
                {{element.estado}}
              </td>
            </ng-container>

            <ng-container matColumnDef="acciones">
              <th mat-header-cell *matHeaderCellDef>Acciones</th>
              <td mat-cell *matCellDef="let element"> 
                <app-adjuntar-documento *ngIf="element.idEstado == 0 || element.idEstado == 2" [codigoSolicitud]="codigoSolicitud" [filename]="element.nombre" [idSolicitud]="idSolicitud" [model]="element" [tipoSeccion]="tipoSeccion" (onUploadFinished)="addItem($event)" (onRemoveDocument)="removeItem($event)"></app-adjuntar-documento>
              </td>
            </ng-container>
            
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
          </table>
        </div>
        </mat-tab>
        <mat-tab label="Historial Comentarios">
          <app-log-table [listaLogModel]="logs"></app-log-table>
        </mat-tab>
      </mat-tab-group>

        <!-- <div class="block-content">
        </div> -->
    </div>
  </div>
  <div class="content">
    <div class="form-horizontal">
      <div class="form-group">
        <label class="col-md-2 control-label">Comentarios:</label>
        <div class="col-md-9">
          <mat-form-field class="example-full-width" appearance="outline">
            <mat-label>Comentarios</mat-label>
            <textarea
              matInput
              placeholder="Comentarios"
              rows="5"
              [(ngModel)]="data.persona.comentarios"
              name="comentarios" [maxlength]="2000"
            ></textarea>
            <!-- 
              [disabled]="modelPersona.idEstado === 2" -->
          </mat-form-field>
        </div>
      </div>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end" class="modal-actions">
  <button type="submit" class="btn btn-naranja" [disabled]="modelForm.invalid" mat-button ><mat-icon>save</mat-icon> Guardar</button> 
  <!-- [disabled]="!EsValido()" -->
  <!-- [mat-dialog-close]="data" -->
  <!-- <button type="submit" id="btnGuardar" class="btn btn-celeste" [disabled]="modelForm.invalid" (click)="guardar()">Submit</button> -->
  <button type="button" class="btn btn-naranja2" mat-button  (click)="onNoClick()"><mat-icon>exit_to_app</mat-icon> Salir</button>
</mat-dialog-actions>

</form>
<!-- <div style="overflow-y: visible; height: 40px;">
  <pre>{{data | json}}</pre>
</div> -->
<!-- <pre>{{data.persona.documentos | json}}</pre> -->